export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8471.5b09d15f.jpg";